module.exports = __webpack_public_path__ + "img/icon_close.5ccb1dd7.svg";